import { DataView } from "primereact/dataview";
import MeaStudentAvatar from "../../../trainings/components/MeaStudentAvatar";
import { classNames } from "primereact/utils";
import MeaLoadingContent from "../../../../components/MeaLoadingContent";

const TodayBackAloneComponent = ({ todaySessions, objectQuery, schoolId, trainingId }) => {


  const todaySessionBackAlonesTemplate = (session, index) => {
    return (
      <div className={classNames('col-12 ')} key={session.id}>
        <div className={classNames('flex flex-column pt-2 pb-2 xl:flex-row xl:align-items-start gap-2', { 'border-top-1 surface-border': index !== 0 })}>
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-2">
            <div className="flex flex-column align-items-center sm:align-items-start gap-1">
              {session.attendances.length === 0 && (<span className="text-500">-</span>) || session.attendances.map((attendance) => (
                attendance?.status !== "ABSENT" && attendance?.student?.authorized_back_alone && (
                  <div key={attendance.id} className="flex align-items-center gap-2">
                    <MeaStudentAvatar student={attendance.student} schoolId={schoolId} trainingId={trainingId} />
                    <span className="text-900 font-medium">{attendance.student.name}</span>
                  </div>
                )
              ))}
              {session.attendances.length === 0 || !session.attendances.some(attendance => attendance?.student?.authorized_back_alone) && (
                <span className="text-500">-</span>
              )}
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              <div className="flex gap-2">
                <span className="text-l text-500">{session?.schedule_item?.classe?.name}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const listTemplate = (items) => {
    if (!items || items.length === 0) return (
      <span className="text-500">Pas de séances aujourd'hui.</span>
    );

    let list = items.map((session, index) => {
      return todaySessionBackAlonesTemplate(session, index);
    });
    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <>
      <MeaLoadingContent objectQuery={objectQuery}>
        <DataView value={todaySessions} listTemplate={listTemplate} emptyMessage="Pas d'élèves." />
      </MeaLoadingContent>
    </>
  );
}

export default TodayBackAloneComponent;